import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerStandardChartFormatting } from './utils/chartFormatting';

registerStandardChartFormatting();

// Apply saved theme before first paint to avoid flash
const savedTheme = typeof window !== 'undefined' && window.localStorage.getItem('climateplans-theme');
const initialTheme = savedTheme === 'dark' || savedTheme === 'light' ? savedTheme : 'light';
document.documentElement.setAttribute('data-theme', initialTheme);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
